module.exports = __webpack_public_path__ + "static/media/icononomegustomagenta.1b577235.svg";